import { css } from "@emotion/react";
import { BugReport } from "@material-ui/icons";
import styled from "../../../../../config/emotion";

export const accountContainerCss = css`
  border-left: 1px solid #c0c6d0;
  position: relative;
  padding: 0 0.5em;

  @media only screen and (max-width: 990px) {
    border-left: 0;
    padding: 0;
  }
`;

export const BugIcon = styled(BugReport)`
  color: ${({ theme }): string => theme.colors.delete};
  font-size: 18px !important;
  position: absolute;
  top: -6px;
  left: 30px;
`;

export const ListItem = styled.li`
  position: relative;
  height: 3.5rem;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  list-style: none;
`;

export const AccountWrapperBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  border: none;
  background-color: transparent;
`;

export const AccountCollapse = styled("div", {
  shouldForwardProp: (prop) => prop !== "isOpen",
})<{ isOpen: boolean }>`
  z-index: 99999;
  position: absolute;
  right: 0;
  width: 300px;
  top: 3.2rem;
  max-height: calc(100vh - 5rem);

  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
`;
